import React from 'react';

const { dictionary, language } = startup;

export default ({ slides }) =>
  slides.map((slide, idx) => (
    <div
      className={`lease-slider__slide lease-slider__slide-${idx} sp-slide`}
      style={{
        backgroundImage: slide.url,
        backgroundPositionX: 'center',
      }}
      key={slide.title}
    >
      <div
        className="sp-layer shadow"
        data-width="100%"
        data-show-transition="left"
        data-hide-transition="left"
        data-show-duration="800"
        data-show-delay="300"
        data-hide-delay="600"
      >
        <div className="lease-slider__wrap">
          <h3
            className="sp-layer"
            data-show-transition="left"
            data-hide-transition="left"
            data-show-duration="800"
            data-show-delay="400"
            data-hide-delay="400"
          >
            {slide.title}
          </h3>
          <a
            className="b-find__btn btn btn-primary sp-layer"
            data-show-transition="left"
            data-hide-transition="left"
            data-show-duration="800"
            data-show-delay="600"
            data-hide-delay="300"
            href={`../${language}/leasing`}
          >
            {dictionary.LeaseButton}
          </a>
        </div>
      </div>
    </div>
  ));
